import { ErrorOutline } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

type ErrorDisplayProps = { message?: string };

const ErrorDisplay: React.FC<ErrorDisplayProps> = (props) => {
  const { message } = props;

  return (
    <Box sx={{ display: "grid", placeItems: "center", gap: 2, padding: 4 }}>
      <ErrorOutline color="error" sx={{ fontSize: "3rem" }} />
      <Typography>{message || "Något gick fel"}</Typography>
    </Box>
  );
};

export default ErrorDisplay;
